import "./styles.scss";
import vectorMini from "../../../assets/fonts/vectorMini.svg";
import vectorSelect from "../../../assets/fonts/vectorSelect.svg";
import { FC, useState, useEffect } from "react";
import { useClickOutside } from "../../../hooks/useClickOutside";
import axios from "axios";
import { API_URL } from "../../../constants/base";


interface User {
  name: string;
  id: number;
}

type Props = {
  isRequired?: boolean;
  label: string;
  list: User[];
  value: string;
  placeholder: string;
  handleSelect: (value: string) => void;
  onChangeClose?: boolean;
  hasMultipleWorkspaces: boolean;
  // setIdSelectedWorkspaces: any;
};

export const SelectWorkspace: FC<Props> = ({
  onChangeClose,
  label,
  list,
  value,
  placeholder,
  handleSelect,
  isRequired,
  hasMultipleWorkspaces,
  // setIdSelectedWorkspaces,
}) => {
  const [open, setOpen] = useState(false);
  const [idSelectedWorkspaces, setIdSelectedWorkspaces] = useState(null);

  const handleOpen = () => {
    setOpen(!open);
  };
  useEffect(() => {
    if (idSelectedWorkspaces) {
      // dispatch(switchWorkspace({ workspaceId: 10 }));
      axios
        .post(API_URL + "/api/auth/switch-workspace", {
          workspaceId: idSelectedWorkspaces,
        })
        .then((response) => {
          if (response.status === 200) {
            window.location.href = "/";
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [idSelectedWorkspaces]);

  const handleBlur = () => {
    setOpen(false);
  };

  const ref = useClickOutside({ handler: handleBlur });

  return (
    <>
      {hasMultipleWorkspaces && (
        <div className="select-workspace-create-household-select" ref={ref}>
          <label className="select-workspace-create-household-select__label">
            {label}
            {isRequired && <span style={{ color: "red" }}>*</span>}
          </label>
          <span
            className={`select-workspace-create-household-select__span ${open && "select-workspace-create-household-select_active-arrow"
              }`}
          >
            <img src={vectorMini} alt="" style={{ width: "10px" }} />
          </span>
          <div
            className="select-workspace-create-household-select__input"
            onClick={handleOpen}
          >
            {value ? value : placeholder}
          </div>
          <div
            className={`select-workspace-create-household-select__list-container ${open && "select-workspace-create-household-select_open"
              }`}
          >
            <div className="select-workspace-create-household-multi-select__list-items">
              {list.map((elem) => {
                return (
                  <div
                    className={`select-workspace-create-household-select__list ${value === elem.name &&
                      "select-workspace-create-household-select_active"
                      }`}
                    key={elem.id}
                    onClick={() => {
                      if (onChangeClose) handleOpen();
                      handleSelect(elem.name);
                      //@ts-ignore
                      setIdSelectedWorkspaces(elem.id);
                    }}
                  >
                    {elem.name}
                    <div
                      className={`select-workspace-create-household-select__list-arrow ${value === elem.name &&
                        "select-workspace-create-household-select_active-check"
                        }`}
                    >
                      <img src={vectorSelect} alt="" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
